import { useRecoilValue } from 'recoil';
import {
  ButtonBase,
  type ButtonBaseProps,
  Icon,
  type IconVariant,
  Paper,
  Stack,
  Typography,
} from '@zurich/ui/atoms';
import { styled } from '@zurich/ui/legacy/utils';
import type { AutoArea } from '~/lib/types';
import { numberOfDamagesPerStepSelector } from '~/state';

type ButtonBarProps = {
  text: string;
  icon: IconVariant;
  onClick: ButtonBaseProps['onClick'];
  area?: AutoArea;
};

export function ButtonBar({ icon, onClick, text, area }: ButtonBarProps) {
  const numberOfDamages = useRecoilValue(numberOfDamagesPerStepSelector(area));

  return (
    <ButtonBase onClick={onClick} width="100%">
      <Paper>
        <StyledStack
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
        >
          <Icon variant={icon} />
          <Typography color="darkBlue" variant="body2 regular">
            {text}
          </Typography>
          <Typography color="black" variant="body2 regular">
            {numberOfDamages}
          </Typography>
          <Icon variant="arrow-right-2" />
        </StyledStack>
      </Paper>
    </ButtonBase>
  );
}

const StyledStack = styled(Stack)(({ theme }) => ({
  color: theme.palette.primary.main,
  columnGap: theme.spacing(3),
  [theme.breakpoints.down('md')]: {
    columnGap: theme.spacing(1),
  },
}));
